import { z } from "zod";
import { defineStepConfig } from "../../registry/helpers";

const ColumnTypeSchema = z.enum([
  "string",
  "integer",
  "float",
  "boolean",
  "date",
]);

const ColumnSnapshotSchema = z.object({
  name: z.string().min(1),
  type: ColumnTypeSchema,
});

export const statefulTableLookupRowStep = defineStepConfig({
  type: "stateful_table_lookup_row",
  name: "Stateful Table Lookup Row",
  description:
    "Look up a single row in a stateful table by its key column. Outputs one typed socket per column from the table's current schema.",
  category: "Data Access",

  inputSchema: z.object({
    key: z
      .string()
      .min(1)
      .describe("The value to look up against the table's key column."),
  }),

  outputSchema: z.object({
    frameNumber: z.number().int().min(1),
    versionNumber: z.number().int().min(1),
  }),

  configSchema: z.object({
    tableDefinitionId: z
      .string()
      .uuid()
      .describe("ID of the stateful table to read from"),
    columns: z
      .array(ColumnSnapshotSchema)
      .min(1)
      .describe(
        "Snapshot of the table's column schema at design time. Drives the per-column output sockets.",
      ),
  }),

  emits: [] as const,

  execution: {
    startToCloseTimeout: "2 minutes",
    retry: { maximumAttempts: 2 },
  },
});
